import { AdditionalButtonProps } from '@components/Button/Button.types';
import { ButtonProps } from '@mui/material';
import { Button } from 'components/Button/Button';
import { useNavigate } from 'react-router';
import { ROUTES } from 'routing/routes';
import { useIntlByKey } from 'services/i18n/hooks/useIntlByKey';

export const ReturnToHomeButton: React.FC<Partial<ButtonProps & AdditionalButtonProps>> = (
  props,
) => {
  const intl = useIntlByKey('common');

  const navigate = useNavigate();

  const redirectToHomePage = () => {
    navigate(ROUTES.HOME);
  };

  return (
    <Button displayStyle="filledOrange" bigPaddings onClick={redirectToHomePage} {...props}>
      {intl('return-home-button')}
    </Button>
  );
};
